export default __webpack_public_path__ + "static/char-s-08-kr-730501fa56a77cae69d96dc16517e0fd.png";